









































import { Vue, Component, Prop } from 'nuxt-property-decorator'
import { computed, defineComponent, ref } from '@nuxtjs/composition-api'
import { FormInputText } from '@/contracts/FormInput'
import { FormInputType } from '@/contracts/FormInputType'

@Component
class InputTextarea extends Vue implements FormInputText {
  @Prop() readonly id: string = ''
  @Prop() readonly label: string = ''
  @Prop() readonly lang: string = ''
  @Prop() readonly value: string = ''
  @Prop() readonly type: FormInputType = FormInputType.Text
  @Prop() readonly placeholder: string = ''
  @Prop() readonly error: boolean | string = false
  @Prop() readonly rules: ReadonlyArray<string> = []
  @Prop() readonly maxlength: number | undefined
  @Prop() readonly withBorder: boolean = false
  @Prop() readonly isNewStyle: boolean = false
  static options: any
}

export default defineComponent({
  name: 'InputTextarea',
  props: InputTextarea.options.props,

  setup(props: InputTextarea, { emit }: { emit: Function }) {
    const countSymbols = computed(() => {
      if (props.value) return props.maxlength - props.value.length
      return props.maxlength
    })
    const isFocused = ref(false)
    const onInput = (val: any) => {
      emit('input-change', val.target.value)
    }
    const onBlur = () => {
      isFocused.value = false
      emit('blur')
    }

    return {
      isFocused,
      onInput,
      countSymbols,
      onBlur,
    }
  },
})
